//
// README
//
// Please reach out to #cadence if you have any questions or concerns with this component.
//

import React from 'react';
import I18n from 'i18n-js';
import { RCIcon, RCSegmentedControl } from '@reverbdotcom/cadence/components';
import { ThemeType } from '@reverbdotcom/cadence/components/types';
import { useTheme } from './theme_context_provider';

import { SunIcon, MoonIcon } from '@reverbdotcom/cadence/icons/react';

export function WebThemeControl() {
  const { theme, updateTheme } = useTheme();
  const LIGHT = ThemeType.webLight;
  const DARK = ThemeType.webDark;

  function handleClick(newTheme) {
    if (newTheme === theme) return;
    updateTheme(newTheme);
  }

  return (
    <div className="web-theme-control">
      <RCSegmentedControl
        aria-label={I18n.t('commons.webThemeControl.theme')}
        size="small"
      >
        <RCSegmentedControl.Button
          selected={theme === LIGHT}
          onClick={() => handleClick(LIGHT)}
          aria-label={I18n.t('commons.webThemeControl.light')}
          iconOnly
        >
          <RCIcon svgComponent={() => <SunIcon />} />
        </RCSegmentedControl.Button>
        <RCSegmentedControl.Button
          selected={theme === DARK}
          onClick={() => handleClick(DARK)}
          aria-label={I18n.t('commons.webThemeControl.dark')}
          iconOnly
        >
          <RCIcon svgComponent={() => <MoonIcon />} />
        </RCSegmentedControl.Button>
      </RCSegmentedControl>
    </div>
  );
}
